import { ContactSlugEnum as e } from "./contact-slug-enum.mjs";
const u = {
  [e.Email]: "public_pages_purchase.contact_slug.email",
  [e.FirstName]: "public_pages_purchase.contact_slug.first_name",
  [e.Surname]: "public_pages_purchase.contact_slug.last_name",
  [e.PhoneNumber]: "public_pages_purchase.contact_slug.phone_number",
  [e.Country]: "public_pages_purchase.contact_slug.country",
  [e.Neighborhood]: "public_pages_purchase.contact_slug.neighborhood",
  [e.StreetAddress]: "public_pages_purchase.contact_slug.street_address",
  [e.StreetNumber]: "public_pages_purchase.contact_slug.street_number",
  [e.City]: "public_pages_purchase.contact_slug.city",
  [e.Postcode]: "public_pages_purchase.contact_slug.postal_code",
  [e.CompanyName]: "public_pages_purchase.contact_slug.company_name",
  [e.TaxNumber]: "public_pages_purchase.contact_slug.tax_number",
  [e.State]: "public_pages_purchase.contact_slug.state_province"
}, _ = (c, t) => t(u[c]), o = (c, t) => {
  const { slug: a, fieldName: s } = c;
  return Object.values(e).includes(a) ? _(a, t) : s;
};
export {
  o as getContactFieldTitle,
  _ as getContactSlugName
};
